var render = function render(){var _vm=this,_c=_vm._self._c;return _c('th',{staticClass:"wrapper"},[_c('div',{class:[
      'sortable-wrapper',
      { 'flex-left': _vm.flexLeft },
      { 'flex-right': _vm.flexRight }
    ]},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }